// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c244af1f","455":"7d5106dc","977":"0587c189"}[chunkId] + ".chunk.js";
};